import React, { useState } from "react";
import ReactGA from "react-ga4";
import usePageTracking from "./hooks/usePageTracking";
import { Routes, Route } from "react-router-dom";

import Navbar from "./components/Navbar/Navbar";
import Footer from "./components/Footer/Footer";
import LandingPage from "./components/LandingPage/LandingPage";
import ProjectsPage from "./pages/ProjectsPage/ProjectsPage";
import AboutPage from "./pages/AboutPage/AboutPage";
import ContactPage from "./pages/ContactPage/ContactPage";
import HomePage from "./pages/HomePage/HomePage";
import AssignmentPage from "./pages/AssignmentPage/AssignmentPage";

ReactGA.initialize("G-4CQPX97ZSC");

export default function App() {
  usePageTracking();

  const [hasEntered, setHasEntered] = useState(false);

  const handleEnter = () => {
    sessionStorage.setItem("dimension-entered", "true");
    setHasEntered(true);
  };

  return (
    <>
      {!hasEntered && <LandingPage onEnter={handleEnter} />}
      <div
        className="app-container"
        style={{ visibility: hasEntered ? "visible" : "hidden" }}
      >
        <Navbar />
        <main className="main-content">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/home" element={<HomePage />} />
            <Route path="/projects" element={<ProjectsPage />} />
            <Route path="/assignments" element={<AssignmentPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/contact" element={<ContactPage />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </>
  );
}